<template>
  <div
    class="dc__item dc__classifiers"
    :class="{ _collapsed: classifiersCollapsed && collapsed }"
  >
    <div><span class="dc-item__label">Классификаторы</span></div>
    <div v-if="isLoading.classifiers">Загрузка...</div>

    <div v-else-if="loadErrors.classifiers.status" class="message _error">
      Ошибка: {{ loadErrors.classifiers.message }}
    </div>

    <div
      v-if="!classifiers.length && !loadErrors.classifiers.status"
      class="message"
    >
      Нет классификаторов
    </div>

    <template v-else>
      <div
        v-for="(dbClassifiers, dbIndex) in classifiers"
        :key="dbIndex"
        class="dc-classifiers__section"
      >
        <div
          v-for="(classifier, classifierIndex) in dbClassifiers.classifiers"
          :key="classifierIndex"
          class="dc-classifier"
        >
          <div class="dc-classifier__title">
            <div
              class="base__icon"
              :style="getDbIconUrl(dbClassifiers.dbId)"
              :title="getDbName(dbClassifiers.dbId)"
            />
            <span>{{ classifier.name }}</span>
          </div>
          <div
            v-for="(path, pathIndex) in classifier.paths"
            :key="pathIndex"
            class="dc-classifier__path"
          >
            <span v-for="(folder, index) in path" :key="index">
              <span
                v-if="index + 1 < path.length"
                class="dc-classifier__branch"
              >
                <span>{{ folder.name }} </span>
                <svg class="dc-classifier__separator" width="10" height="10">
                  <use xlink:href="#chevron" />
                </svg>
              </span>
              <router-link
                v-else
                :to="makeSearchRoute(folder.id)"
                class="dc-classifier__link"
                v-text="folder.name"
              />
            </span>
          </div>
        </div>
        <div
          v-if="classifiersCollapsed"
          class="dc__show-more"
          :class="{ _opened: !collapsed }"
          @click="collapsed = !collapsed"
        >
          <a href="#" class="dc-show-more__link">{{ collapsedText }}</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUTE_SEARCH } from '@src/routes';

export default {
  props: {
    classifiers: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    collapsed: true
  }),

  computed: {
    ...mapGetters({
      isLoading: 'documentIsLoading',
      loadErrors: 'loadErrors'
    }),
    databases() {
      return this.$store.state.databases;
    },

    classifiersCount() {
      return this.classifiers.reduce((a, b) => {
        return a + b.classifiers.length;
      }, 0);
    },

    classifiersCollapsed() {
      return this.classifiersCount > 3;
    },

    collapsedText() {
      return this.collapsed
        ? `Показать все классификаторы (${this.classifiersCount})`
        : 'Свернуть классификаторы';
    }
  },

  methods: {
    getDbIconUrl(dbId) {
      return this.databases[dbId]
        ? { backgroundImage: `url('${this.databases[dbId].iconUrl}')` }
        : '';
    },
    getDbName(dbId) {
      return this.databases[dbId] ? this.databases[dbId].name : null;
    },
    makeSearchRoute(classifierId) {
      return {
        name: ROUTE_SEARCH,
        query: {
          classifiers: classifierId
        }
      };
    }
  }
};
</script>
